<template>
    <div id="prijat_modal" class="prijat_modal">
        <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x"
            crossorigin="anonymous"
        />
        <div class="modal-content p-2">
            <div class="row">
                <div class="col-lg-12 pb-0">
                    <div
                        class="d-flex justify-content-center align-items-center"
                    >
                        <div class="formular_nadpis p-0">
                            {{ $t("suhlasite_y_nadpis") }}
                        </div>
                        <span class="btn_close" id="close_prijat">&times;</span>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10 pt-0">
                    <div class="form-floating">
                        <input
                            v-model="ponuka.firma"
                            type="text"
                            class="form-control"
                            id="floatingNazov"
                            placeholder="Názov firmy"
                        />
                        <label for="floatingNazov">
                            {{ $t("suhlasite_y_nazov") }}
                        </label>
                    </div>
                    <div
                        class="form-floating"
                        :style="errors.meno ? 'border: 1px solid #F93C34' : ''"
                    >
                        <input
                            v-model="ponuka.meno"
                            type="text"
                            class="form-control"
                            id="floatingNazov"
                            placeholder="Meno a priezvisko"
                        />
                        <label for="floatingNazov">
                            {{ $t("suhlasite_y_meno") }}
                            <span class="text-danger">*</span>
                        </label>
                    </div>
                    <div
                        class="form-floating"
                        :style="errors.email ? 'border: 1px solid #F93C34' : ''"
                    >
                        <input
                            v-model="ponuka.email"
                            type="email"
                            class="form-control"
                            id="floatingNazov"
                            placeholder="Email"
                        />
                        <label for="floatingNazov">
                            {{ $t("suhlasite_y_email") }}
                            <span class="text-danger">*</span></label
                        >
                    </div>
                    <div class="flex-inputs">
                        <div class="form-floating input_two">
                            <input
                                @keypress="ico_checker"
                                v-model.number="ponuka.ico"
                                type="text"
                                class="form-control"
                                id="floatingInput"
                                placeholder="IČO"
                            />
                            <label for="floatingInput">
                                {{ $t("suhlasite_y_ico") }}</label
                            >
                            <span class="counter">{{ ico_counter }}/8</span>
                        </div>
                        <div class="form-floating input_one">
                            <input
                                @keypress="dic_checker"
                                v-model.number="ponuka.dic"
                                type="text"
                                class="form-control"
                                id="floatingInput"
                                placeholder="DIČ"
                            />
                            <label for="floatingInput">
                                {{ $t("suhlasite_y_dic") }}</label
                            >
                            <span class="counter">{{ dic_counter }}/10</span>
                        </div>
                    </div>
                    <div class="form-floating dic">
                        <input
                            v-model.number="ponuka.icdph"
                            type="text"
                            class="form-control"
                            id="floatingInput"
                            placeholder="IČ DPH"
                        />
                        <label for="floatingInput">
                            {{ $t("suhlasite_y_ic_dph") }}</label
                        >
                    </div>
                    <div class="form-floating textarea">
                        <textarea
                            v-model="ponuka.text"
                            class="form-control"
                            placeholder="Text"
                            id="floatingTextarea2"
                        >
                        </textarea>
                        <label for="floatingTextarea2">
                            {{ $t("suhlasite_y_text") }}</label
                        >
                    </div>
                    <p class="formular_popis">
                        {{ $t("suhlasite_y_info") }}
                    </p>
                    <div class="formular_btn pt-2">
                        <div
                            @click="submit"
                            class="ulozit"
                            :style="
                                'border: 1px solid' +
                                color +
                                '; ' +
                                'color: ' +
                                color +
                                ';'
                            "
                        >
                            <span v-show="!saved">
                                {{ $t("suhlasite_y_odoslat") }}
                            </span>
                            <div v-show="saved" class="lds-ellipsis green">
                                <div :style="'background:' + color + ';'"></div>
                                <div :style="'background:' + color + ';'"></div>
                                <div :style="'background:' + color + ';'"></div>
                                <div :style="'background:' + color + ';'"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["offer_id", "color"],
    data() {
        return {
            ico_counter: 0,
            dic_counter: 0,
            saved: false,
            ponuka: {
                confirmed: 1,
                send: 1,
                firma: "",
                meno: "",
                email: "",
                ico: "",
                dic: "",
                icdph: "",
                text: "",
            },
            errors: {},
        };
    },
    created() {},
    methods: {
        ico_checker(event){
            const inputVal = event.target.value;
            const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
            if (cleanedVal.length > 7) {
                this.ponuka.ico = cleanedVal.substr(0, 7); // Limit length to 8 characters
            } else {
                this.ponuka.ico = cleanedVal;
            }
        },
        dic_checker(event){
            const inputVal = event.target.value;
            const cleanedVal = inputVal.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
            if (cleanedVal.length > 9) {
                this.ponuka.dic = cleanedVal.substr(0, 9); // Limit length to 8 characters
            } else {
                this.ponuka.dic = cleanedVal;
            }
        },
        getErrors() {
            this.errors = {};
            if (this.ponuka.meno == "") this.errors["meno"] = true;

            if (this.ponuka.email == "") this.errors["email"] = true;
        },
        submit() {
            this.getErrors();
            if (Object.keys(this.errors).length === 0) {
                this.ponuka["offer_id"] = this.offer_id;
                this.saved = true;
                axios.post("/api/poPonuka", this.ponuka).then((response) => {
                    // const gtmEventData = {
                    //     event: 'email_quote_sent',
                    //     'Event category': 'email',
                    //     'Event action': 'successfull_sent_email',
                    //     'Event label': 'for_client___accept_offer'
                    // };
                    // const gtmEventData1 = {
                    //     event: 'email_quote_sent',
                    //     'Event category': 'email',
                    //     'Event action': 'successfull_sent_email',
                    //     'Event label': 'for_user___accept_offer'
                    // };
                    // //one email for user
                    // this.$gtm.push(gtmEventData);
                    // //one email for client
                    // this.$gtm.push(gtmEventData1);
                    this.saved = false;
                    window.location.reload();
                });
            }
        },
    },
    watch: {
        ponuka: {
            deep: true,
            handler() {
                this.ico_counter = this.ponuka.ico.toString().length;
                this.dic_counter = this.ponuka.dic.toString().length;
            },
        },
    },
};
</script>

<style lang="scss" scoped>
* {
    font-family: "Montserrat";
}
.prijat_modal {
    display: none;
    position: fixed;
    z-index: 15;
    padding-top: 100px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}
.modal-content {
    background-color: #fefefe;
    width: 600px !important;
    height: auto;
    border-radius: 15px;
    box-shadow: 0 34px 74px 0 rgba(0, 0, 0, 0.1);
    margin: auto;
    padding: 20px;
    position: relative;
}
.ulozit {
    margin: 15px auto 0 auto;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100px;
    height: 50px;
    box-sizing: border-box;
    border-radius: 4px;
    font-family: Roboto, "Montserrat";
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
}
.formular_popis {
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    line-height: 150%;
    text-align: center;
    color: #212541;
    width: 90%;
    margin: 15px auto 0px auto;
}
.btn_close {
    position: absolute;
    right: 7px;
    top: -5px;
    font-size: 30px;
    cursor: pointer;
}
.textarea > .form-control:focus {
    padding: 0 0 0 15px !important;
}
.textarea {
    border: 1px solid #dde3e8;
    border-radius: 0;
    textarea {
        border: none !important;
        border-top: 25px solid transparent !important;
        padding-top: 0;
        width: 100%;
        height: 120px;
        background: #ffffff;
        box-sizing: border-box;
    }
}
textarea,
input {
    font-family: Roboto, "Montserrat";
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;

    color: #212541;

    border: 1px solid #dde3e8;
    border-radius: 0;
}
.flex-inputs {
    display: flex;
    width: 100%;
    .input_one {
        width: 55%;
        margin-left: auto;
    }
    .input_two {
        width: 40%;
    }
}
.modal-content {
    border: none;
}
.form-floating {
    position: relative;
    .counter {
        position: absolute;
        right: 5px;
        bottom: 5px;
        font-size: 10px;
        font-weight: 300;
        color: #9598a7;
    }
}
.form-floating {
    margin-top: 15px;
}
.form-floating > label {
    padding: 22px 13px;
}
.form-floating > label,
.float-container label {
    font-family: Roboto, "Montserrat";
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9598a7;
}
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}
</style>
